import _ from 'lodash';
import moment from 'moment';
import * as phoneformat from 'phoneformat.js';

export const processors = {
    choiceProcessor: ['$injector', $injector => {
        return (ngConstant, options = {}) => {
            const CHOICES = $injector.get(ngConstant);

            let findChoice = (choice) => {
                choice = _.isObject(choice) ? choice.key : choice;
                return _.find(
                    CHOICES,
                    choiceObj => choice === choiceObj.key || choice === choiceObj.value
                );
            };

            let field = {
                loader: choice => findChoice(choice),
                dumper: choice => _.isObject(choice) ? choice.key : findChoice(choice).key
            };

            field = _.extend(field, options);

            return field;
        };
    }],

    dateProcessor: () => {
        return (conf = {}, options = {}) => {
            let field = {
                loader: datetime => {
                    let ts = moment(datetime);
                    return conf.toDate ? ts.toDate() : ts;
                },
                dumper: datetime => {
                    let ts = moment(datetime);
                    return conf.datetime ? ts.toISOString() : ts.format('YYYY-MM-DD');
                }
            };
            field = _.extend(field, options);
            return field;
        };
    },

    phoneProcessor: ['DEFAULT_COUNTRY', (DEFAULT_COUNTRY) => {
        return {
            dumper: (phone) => phoneformat.formatE164(DEFAULT_COUNTRY, phone),
            loader: (phone) => phoneformat.formatInternational(DEFAULT_COUNTRY, phone)
        };
    }],

    phoneValidator: ['DEFAULT_COUNTRY', DEFAULT_COUNTRY => {
        let nullyValue = value => {
            return value === undefined ||
                   value === null ||
                   (typeof value === 'string' && value.length === 0);
        };
        return (resource, phone, msgError) => {
            return nullyValue(phone) ||
                   phoneformat.isValidNumber(phone, DEFAULT_COUNTRY) ||
                   msgError || 'validation.phone';
            };
    }]    
};



// WEBPACK FOOTER //
// ./scripts/processors.js